module.exports = __webpack_public_path__ + "static/media/assembly12.5ec3e6a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameRocketRepair/assembly12.png
// module id = 2430
// module chunks = 0